<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <RadioGroup :options="radioData" @radioChange="radioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" :formCtrl2="formCtrl2" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <template #middle>
        <!-- 复合下拉框 -->
        <CompositeFormSelect ref="comFormSelect" :options="selectKeyOptions" :valueOptionsData="selectValueOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormSelect>
      </template>
      <template #end>
        <el-form-item v-show="[1, 2, 3, 4].includes(user.user_group_id)">
          <el-button type="success" @click="settle">批量结算</el-button>
        </el-form-item>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运单列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showSelect="[1, 2, 3, 4].includes(user.user_group_id)" :showTotal="true" :getTotal="getTotal"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #open="params">
        <MySwitch v-if="[1, 2, 3, 4].includes(user.user_group_id)" :data="params.params" :activeValue="'2'"
          :inactiveValue="'1'" @onToggle="toggleDisplay"></MySwitch>

        <span v-else>{{ params.params.settled == 1 ? '未结算' : '已结算' }}</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'shipperrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/shipper` },
        { name: "应收账款管理", path: `/finance/shipper` },
        { name: "运单列表" },
      ],
      wxtsList: [
        {
          name: '应收运费=公司运费-亏吨金额+补差金额'
        },
      ],
      radioData: [
        { label: "全部运单", value: 1 },
        { label: "普通运单", value: 3 },
        { label: "合同运单", value: 2 },
      ],
      formInline: {
        index: 1,
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
      ],
      formCtrl2: [
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
        // {
        //   label: "结算",
        //   keyName: "settled",
        //   placeholder: "请选择",
        //   type: "select",
        //   options: [
        //     { label: '全部', value: '' },
        //     { label: '未结算', value: 1 },
        //     { label: '已结算', value: 2 },
        //   ],
        // },
      ],
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      selectKeyOptions: [
        { label: '运单类型', value: 'ischeck', },
        { label: '结算状态', value: 'settled', },
      ],
      selectValueOptions: {
        ischeck: [
          { label: '全部', value: null },
          { label: '自有', value: 1, },
          { label: '外协', value: 2, },
        ],
        settled: [
          { label: '全部', value: 0 },
          { label: '未结算', value: 1 },
          { label: '已结算', value: 2 },
        ],
      },
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 140 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "name", label: "货物名称", minwidth: 150 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 150 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 150 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 140 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', width: 110 },
        // { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "infreight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "freight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "actual_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "open", label: "结算", slot: "open" },
        { keyName: "repaytime", label: "预计结款日期", minwidth: 120 },
      ],
      getTotalProperty: [
        "kuiton",
        "kuitotal",
        "additional_fees",
        'compen',
        'freight',
        'inton',
        'unton',
        'caton',
        'actual_freight',
      ],
      baseParams: ['index', 'shipperid'],
    };
  },
  methods: {
    setFleet({ team }) {
      this.formCtrl.map(v => {
        // console.log(team)
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      this.$forceUpdate()
    },
    radioChange(v) {
      // console.log(v);
      this.formInline.index = v
      this.getList();
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.settled + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    settle() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '请选择条目!',
        });
        return
      }
      let count = 0
      const arr = []
      this.selection.map(v => {
        count += Number(v.freight) - Number(v.kuitotal) + Number(v.compen)
        arr.push(v.id)
      })
      // console.log(this.selection)
      this.$confirm(`结算金额为${count}元？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.settleReq(arr);
      }).catch(() => { });
    },
    settleReq(delList) {
      let url = `custom/settlement`;
      const params = {
        // userid: this.user.id,
        delList,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    toggleDisplay({ id }) {
      let url = `custom/upsettled`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      // 车队长登录，默认搜索当前队长
      this.formInline.fleet = id
      // 不显示队长控件
      this.formCtrl.length = 0
      // 重置时保留队长检索
      this.baseParams.push('fleet')
      // 本身有baseParams不需要手动触发getList
    }
  },
  mounted() {
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}

/deep/ .el-form--inline {
  .item:nth-child(1) {
    margin-right: 10px;
  }

  .item:nth-child(2) {
    margin-right: 10px;
  }

  .item:nth-child(3) {
    margin-right: 10px;
  }

  .item:nth-child(4) {
    margin-right: 10px;
  }
}
</style>
